import {PropsWithChildren, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import {AppDeviceController} from '../controller'

const DeviceWrapper = observer(({children}: PropsWithChildren) => {
  const appDeviceController = useService(AppDeviceController, []);

  useEffect(() => {
    (async () => {
      // Dev
      // await appDeviceController.delete();

      await appDeviceController.load();

      if (!appDeviceController.device) {
        await appDeviceController.set();
      } else {
        // TODO: This is temporal, it should be removed
        // This is to remove the device if the database was reset

        const valid = await appDeviceController.validate();

        if (!valid) {
          await appDeviceController.delete();
          await appDeviceController.set();
        }
      }
    })();
  }, []);

  if (
    !appDeviceController.loaded
  ) {
    return null;
  }

  return <>
    {children}
  </>
});

export {DeviceWrapper};
